/**
 * ? @description : Navigation Bar for Login Page
 */

// Dependencies
import React, { Fragment } from "react";
import { Navbar } from "react-bootstrap";

// Assets
import ltelogo from "./../../assets/logov1.svg";

// CSS
import "./../../css/Login.css";

// Component
import Login from "../Login/Login";

function LoginNavBar() {
  return (
    <Fragment>
      {/* Navigation Bar */}
      <Navbar className="login-admin">
        <Navbar.Brand href="#">
          <div className="navbar-brand">
            <img className="ltelogo" src={ltelogo} alt="Logo" />
            <span className="login-admin-title">Lets Teach English</span>
          </div>
        </Navbar.Brand>
      </Navbar>

      {/* Login Form Component */}
      <Login />
    </Fragment>
  );
}

export default LoginNavBar;
